import { render, staticRenderFns } from "./AutoPostBoostingConditionItem.vue?vue&type=template&id=40c56066&scoped=true&"
import script from "./AutoPostBoostingConditionItem.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingConditionItem.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingConditionItem.vue?vue&type=style&index=0&id=40c56066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c56066",
  null
  
)

export default component.exports